import { IonButton, IonItemGroup, IonLabel } from "@ionic/react";
import React from "react";

import CommentModal from "../../../atoms/CommentModal";

import styles from "./ReportForm.module.scss";

export interface ReportFormProps {
  isOpen: boolean;
  close: () => void;
  report: () => void;
}

const ReportForm = (props: ReportFormProps) => {
  return (
    <CommentModal
      isOpen={props.isOpen}
      className={styles.wrapper}
      onClickBackdrop={props.close}
    >
      <div>
        <div className={styles.form}>
          <IonItemGroup className={styles.item}>
            <IonLabel color="light" className={styles.label}>
              <h2 className={styles.title}>報告</h2>
              この投稿を不適切な内容として報告します。
              <br />
              報告内容は管理者が確認し、
              <br />
              必要に応じて対応します。
            </IonLabel>
            <div className={styles.buttonArea}>
              <IonButton className={styles.cancelButton} onClick={props.close}>
                キャンセル
              </IonButton>
              <IonButton className={styles.reportButton} onClick={props.report}>
                報告する
              </IonButton>
            </div>
          </IonItemGroup>
        </div>
      </div>
    </CommentModal>
  );
};

export default ReportForm;
